module.exports = __webpack_public_path__ + "media/images/landing/client_Lake_Charles-0061fef4ab56fb5afcee915be98ae46c.png";